import { useQuery } from '@tanstack/react-query';
import { tokenApi } from '~endpoints/Token';
import { useWebView } from '@myrealtrip/device-detect';
import { tokenKeys } from '~queryKeys/tokenKeys';

interface Params {
  enabled?: boolean;
}

export default function useTokenQueryForWeb({ enabled }: Params = {}) {
  const { isWebView } = useWebView();

  return useQuery({
    queryKey: tokenKeys.refresh(),
    queryFn: () => tokenApi.v1.refresh(),
    enabled: typeof enabled === 'boolean' ? enabled : !isWebView,
  });
}
